export default __webpack_public_path__ + "static/media/image.ophtha-innovations.7a65e139.png";